import {fsa, fsaPayload, gateAction} from './helpers'
import * as api from '../api/api'
import {
  getAddressPayload,
  handleAddressResponse,
  handleVendorResponse,
  throwError,
} from '../components/BlackDesk/blackDeskApiHelpers'
import {renameVendorFormFieldsToApiFields} from '../components/BlackDesk/blackDeskUtils'
import * as blackDesk from '../store/blackDesk'
import * as track from '../track/blackDesk'

// -- Actions

export const OPEN_VENDOR_APPLICATION = 'openVendorApplication'
export const openVendorApplication = fsa(OPEN_VENDOR_APPLICATION)

export const SET_VENDOR_ID = 'setVendorId'
export const setVendorId = fsaPayload(SET_VENDOR_ID)

export const SHOW_VENDOR_ADDRESS_FORM = 'showVendorAddressForm'
export const showVendorAddressForm = fsa(SHOW_VENDOR_ADDRESS_FORM)

// -- Thunks

export const CLOSE_VENDOR_APPLICATION = 'closeVendorApplication'
export const _closeVendorApplication = fsa(CLOSE_VENDOR_APPLICATION)
export const closeVendorApplication = gateAction(
  _closeVendorApplication,
  blackDesk.vendorApplicationIsOpen,
)

export const setVendorIdAndShowAddressForm = (response, dispatch) => {
  track.blackDeskVendorSignup(response.email)
  dispatch(setVendorId(response.id))
  dispatch(showVendorAddressForm())
}

export const createVendor = (formValues) => {
  const payload = renameVendorFormFieldsToApiFields(formValues)

  return api.createVendor(payload).then(handleVendorResponse).catch(throwError)
}

export const saveVendorAddress = (formValues) => (_, getState) => {
  const state = getState()
  const payload = getAddressPayload(formValues, state)
  const vendorId = blackDesk.vendorId(state)

  return api.createVendorAddress(payload, vendorId).then(handleAddressResponse).catch(throwError)
}
